import { ReactNode } from 'react';
import styled from 'styled-components';

interface StyledDivProps {
  children?: ReactNode;
}

export const FooterWrapper = styled.div<StyledDivProps>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const FooterText = styled.div<StyledDivProps>`
  font-weight: 600;
  letter-spacing: -0.03125em;
  margin: 15px 0;
  text-align: center;
`;
